var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0533 4.55967C29.8949 3.92689 29.5723 3.3471 29.1182 2.87888C28.664 2.41066 28.0943 2.07059 27.4666 1.89301C25.1733 1.33301 15.9999 1.33301 15.9999 1.33301C15.9999 1.33301 6.82662 1.33301 4.53328 1.94634C3.90561 2.12392 3.33592 2.464 2.88174 2.93222C2.42757 3.40044 2.105 3.98022 1.94662 4.61301C1.5269 6.94042 1.3216 9.30142 1.33328 11.6663C1.31832 14.0491 1.52364 16.4281 1.94662 18.773C2.12123 19.3861 2.45102 19.9439 2.90414 20.3923C3.35726 20.8408 3.91838 21.1648 4.53328 21.333C6.82662 21.9463 15.9999 21.9463 15.9999 21.9463C15.9999 21.9463 25.1733 21.9463 27.4666 21.333C28.0943 21.1554 28.664 20.8154 29.1182 20.3471C29.5723 19.8789 29.8949 19.2991 30.0533 18.6663C30.4698 16.3565 30.6751 14.0135 30.6666 11.6663C30.6816 9.28362 30.4763 6.90461 30.0533 4.55967Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 16.0263L20.6666 11.6663L12.9999 7.30634V16.0263Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtubeWhite.a86f8f659caf7dab8ba85383f62e709d.svg";
export { ForwardRef as ReactComponent };